import React, { useContext, useEffect } from "react";

import { Form } from "react-bootstrap";
import { MainContext } from "../../Context/MainContext";

const MobileSortContainer = () => {
  const { MainState, handleSortSelect, triggerModal } = useContext(MainContext);
  const { useMazdaBranding } = MainState;
  const sortOptions = MainState.sortOptions;
  const sortValue = MainState.sortValue;
  // sortValue may be a "field_dir,field_dir" chain (see MainContext's sortSpecials) when set
  // via a share-link URL. These radios only ever offer single-field options, so reflect just
  // the primary field here — the rest is a tiebreaker the UI was never meant to expose.
  const primarySortValue = sortValue.split(",")[0];

  const handleSort = (value) => {
    handleSortSelect(value);
    triggerModal();
  };

  // Initialize sort value
  useEffect(() => {
    handleSortSelect(sortValue);
  }, []);

  return (
    <div>
      {sortOptions.map((option) => (
        <div className="py-2 mb-1" key={option.value}>
          <Form.Check className={`${useMazdaBranding ? "radio-mazda" : ""} w-100`} custom type="radio" id={option.value}>
            <Form.Check.Input
              name="sort"
              type="radio"
              checked={primarySortValue === option.value}
              onChange={() => handleSort(option.value)}
              className="transition-none"
            />
            <Form.Check.Label className="w-100">
              <div className="d-flex align-items-baseline">
                <span className="font-weight-semibold mr-1 text-nowrap">
                  {option.text}
                </span>
              </div>
            </Form.Check.Label>
          </Form.Check>
        </div>
      ))}
    </div>
  );
};

export default MobileSortContainer;
